/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphDto } from '../../models/submissions-graph-dto';

export interface FactorSubmissionsByBlockGet$Plain$Params {
  clientName?: string;
  date?: string;
}

export function factorSubmissionsByBlockGet$Plain(http: HttpClient, rootUrl: string, params?: FactorSubmissionsByBlockGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphDto>>> {
  const rb = new RequestBuilder(rootUrl, factorSubmissionsByBlockGet$Plain.PATH, 'get');
  if (params) {
    rb.query('clientName', params.clientName, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphDto>>;
    })
  );
}

factorSubmissionsByBlockGet$Plain.PATH = '/Factor/submissions-by-block';
